<template>
  <div style="display: inline-block">
    <span
      role="button"
      class="text-decoration-underline align-self-start"
      style="display: inline-block"
      :class="activatorClass"
      @click="dialog = true"
      >{{ $t('commons.sizeChart') }}</span
    >
    <product-detail-size-table-dialog
      v-if="dialog"
      v-model="dialog"
    ></product-detail-size-table-dialog>
  </div>
</template>

<script>
export default {
  name: 'ProductDetailSizeTable',
  components: {
    ProductDetailSizeTableDialog: () =>
      import('~/components/product/detail/ProductDetailSizeTableDialog'),
  },
  props: {
    activatorClass: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
}
</script>
